import React from 'react';
import { CheckCircle2, Plane, Briefcase, GraduationCap, Heart, Users, FileText } from 'lucide-react';

function VisaCategory({ categories = [], selectedCategory, onSelectCategory }) {

    // Map category names to icons and colors dynamically
    const getCategoryConfig = (categoryName) => {
        // Convert to lowercase for matching
        const name = categoryName.toLowerCase();

        // Check for keywords in category name
        if (name.includes('tourist') || name.includes('tourism') || name.includes('travel')) {
            return {
                icon: Plane,
                gradient: 'from-blue-500 to-cyan-500',
                bgLight: 'bg-blue-50',
                border: 'border-blue-600',
                text: 'text-blue-600'
            };
        }

        if (name.includes('business') || name.includes('work') || name.includes('employment')) {
            return {
                icon: Briefcase,
                gradient: 'from-purple-500 to-pink-500',
                bgLight: 'bg-purple-50',
                border: 'border-purple-600',
                text: 'text-purple-600'
            };
        }

        if (name.includes('student') || name.includes('education') || name.includes('study')) {
            return {
                icon: GraduationCap,
                gradient: 'from-green-500 to-emerald-500',
                bgLight: 'bg-green-50',
                border: 'border-green-600',
                text: 'text-green-600'
            };
        }

        if (name.includes('medical') || name.includes('health') || name.includes('treatment')) {
            return {
                icon: Heart,
                gradient: 'from-red-500 to-rose-500',
                bgLight: 'bg-red-50',
                border: 'border-red-600',
                text: 'text-red-600'
            };
        }

        if (name.includes('conference') || name.includes('seminar') || name.includes('meeting')) {
            return {
                icon: Users,
                gradient: 'from-orange-500 to-amber-500',
                bgLight: 'bg-orange-50',
                border: 'border-orange-600',
                text: 'text-orange-600'
            };
        }

        // Default fallback for any other category
        return {
            icon: FileText,
            gradient: 'from-gray-500 to-slate-500',
            bgLight: 'bg-gray-50',
            border: 'border-gray-600',
            text: 'text-gray-600'
        };
    };

    return (
        <div className="space-y-6">
            {/* Header */}
       
                <h3 className="text-lg font-semibold text-gray-900">
                    Step 1: Select Visa Category
                </h3>
                <p className="text-gray-600">
                    Choose the category that best fits your travel purpose
                </p>
      

            {/* Show message if no categories */}
            {!categories || categories.length === 0 ? (
                <div className="text-center py-12">
                    <p className="text-gray-500">No visa categories available</p>
                </div>
            ) : (
                <div className="space-y-6">
                    {/* Category Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {categories.map((category) => {
                            const config = getCategoryConfig(category);
                            const Icon = config.icon;
                            const isSelected = selectedCategory === category;

                            return (
                                <button
                                    key={category}
                                    onClick={() => onSelectCategory(category)}
                                    className={`group relative p-6 rounded-2xl border-2 transition-all duration-300 text-left overflow-hidden ${isSelected
                                        ? `${config.border} ${config.bgLight} shadow-lg scale-105`
                                        : "border-gray-200 bg-white hover:border-gray-300 hover:shadow-md"
                                        }`}
                                >
                                    {/* Background Gradient Effect */}
                                    {isSelected && (
                                        <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${config.gradient} opacity-10 rounded-full -mr-16 -mt-16`} />
                                    )}

                                    {/* Content */}
                                    <div className="relative z-10">
                                        {/* Icon Container */}
                                        <div className={`inline-flex p-3 rounded-xl mb-4 transition-all duration-300 ${isSelected
                                            ? `bg-gradient-to-br ${config.gradient} shadow-md`
                                            : 'bg-gray-100 group-hover:bg-gray-200'
                                            }`}>
                                            <Icon className={`w-6 h-6 ${isSelected ? 'text-white' : 'text-gray-600'}`} />
                                        </div>

                                        {/* Category Name - Display exactly as received from API */}
                                        <h4 className={`text-sm font-bold mb-1 transition-colors ${isSelected ? config.text : 'text-gray-900'
                                            }`}>
                                            {category}
                                        </h4>

                                        <p className="text-sm text-gray-600">
                                            Apply for {category.toLowerCase()} visa
                                        </p>
                                    </div>

                                    {/* Selected Check Mark */}
                                    {isSelected && (
                                        <div className="absolute top-4 right-4">
                                            <div className={`bg-gradient-to-br ${config.gradient} rounded-full p-1 shadow-lg`}>
                                                <CheckCircle2 className="w-5 h-5 text-white" />
                                            </div>
                                        </div>
                                    )}

                                    {/* Hover Effect */}
                                    {!isSelected && (
                                        <div className="absolute inset-0 bg-gradient-to-br from-transparent to-gray-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                    )}
                                </button>
                            );
                        })}
                    </div>


                </div>
            )}
        </div>
    );
}

export default VisaCategory;